import { CSSProperties, useState } from "react";
import styled from "styled-components";

interface IProps {
  logo?: string | null;
  name?: string;
  /**
   * Prečnik u px. Bez njega važi 52px ili `--avatar-size` koji postavi roditelj
   * (npr. različita veličina na mobilnom, preko `styled(TenantAvatar)`).
   */
  size?: number;
  className?: string;
}

const Frame = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--avatar-size, 52px);
  height: var(--avatar-size, 52px);
  border-radius: 50%;
  overflow: hidden;
  background: var(--color-primary-light);
  border: var(--avatar-ring, 2px) solid var(--color-primary-lighter);
  box-sizing: border-box;
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const Initial = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary-lighter) 100%
  );
  color: var(--color-primary);
  font-weight: var(--weight-bold);
  font-size: calc(var(--avatar-size, 52px) * 0.4);
  line-height: 1;
`;

/**
 * Logo salona u krugu sa ružičastim prstenom; bez logoa (ili ako se slika ne
 * učita) prikazuje početno slovo naziva. Jedan prikaz za sve kartice i liste.
 */
export const TenantAvatar: React.FC<IProps> = ({
  logo,
  name,
  size,
  className,
}) => {
  // Logo koji se nije učitao pamtimo po URL-u, pa novi logo opet dobija šansu.
  const [brokenLogo, setBrokenLogo] = useState<string>();
  const showImage = !!logo && logo !== brokenLogo;

  const style = size
    ? ({
        "--avatar-size": `${size}px`,
        "--avatar-ring": size < 32 ? "1px" : "2px",
      } as CSSProperties)
    : undefined;

  return (
    <Frame className={className} style={style}>
      {showImage ? (
        <Image
          src={logo}
          // Ime salona je uvek prikazano pored, pa je slika dekorativna.
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setBrokenLogo(logo)}
        />
      ) : (
        <Initial aria-hidden="true">{name?.[0]?.toUpperCase()}</Initial>
      )}
    </Frame>
  );
};
